/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { Coupons } from "../models/coupons";
@Injectable({
  providedIn: "root",
})
class AdminCouponsService extends __BaseService {
  static readonly adminCouponsGetCouponsAllPath =
    "/api/admin/subscription/AdminCoupons";
  static readonly adminCouponsPostCouponsPath =
    "/api/admin/subscription/AdminCoupons";
  static readonly adminCouponsGetCouponsPath =
    "/api/admin/subscription/AdminCoupons/{id}";
  static readonly adminCouponsPutCouponsPath =
    "/api/admin/subscription/AdminCoupons/{id}";
  static readonly adminCouponsDeleteCouponsPath =
    "/api/admin/subscription/AdminCoupons/{id}";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  adminCouponsGetCouponsAllResponse(): __Observable<
    __StrictHttpResponse<Array<Coupons>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/subscription/AdminCoupons`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Coupons>>;
      })
    );
  }
  adminCouponsGetCouponsAll(): __Observable<Array<Coupons>> {
    return this.adminCouponsGetCouponsAllResponse().pipe(
      __map((_r) => _r.body as Array<Coupons>)
    );
  }

  /**
   * @param coupons undefined
   */
  adminCouponsPostCouponsResponse(
    coupons: Coupons
  ): __Observable<__StrictHttpResponse<Coupons>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = coupons;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/admin/subscription/AdminCoupons`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Coupons>;
      })
    );
  }
  /**
   * @param coupons undefined
   */
  adminCouponsPostCoupons(coupons: Coupons): __Observable<Coupons> {
    return this.adminCouponsPostCouponsResponse(coupons).pipe(
      __map((_r) => _r.body as Coupons)
    );
  }

  /**
   * @param id undefined
   */
  adminCouponsGetCouponsResponse(
    id: string
  ): __Observable<__StrictHttpResponse<Coupons>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/subscription/AdminCoupons/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Coupons>;
      })
    );
  }
  /**
   * @param id undefined
   */
  adminCouponsGetCoupons(id: string): __Observable<Coupons> {
    return this.adminCouponsGetCouponsResponse(id).pipe(
      __map((_r) => _r.body as Coupons)
    );
  }

  /**
   * @param params The `AdminCouponsService.AdminCouponsPutCouponsParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `coupons`:
   */
  adminCouponsPutCouponsResponse(
    params: AdminCouponsService.AdminCouponsPutCouponsParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.coupons;
    let req = new HttpRequest<any>(
      "PUT",
      this.rootUrl + `/api/admin/subscription/AdminCoupons/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdminCouponsService.AdminCouponsPutCouponsParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `coupons`:
   */
  adminCouponsPutCoupons(
    params: AdminCouponsService.AdminCouponsPutCouponsParams
  ): __Observable<Blob> {
    return this.adminCouponsPutCouponsResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  adminCouponsDeleteCouponsResponse(
    id: string
  ): __Observable<__StrictHttpResponse<Coupons>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/api/admin/subscription/AdminCoupons/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Coupons>;
      })
    );
  }
  /**
   * @param id undefined
   */
  adminCouponsDeleteCoupons(id: string): __Observable<Coupons> {
    return this.adminCouponsDeleteCouponsResponse(id).pipe(
      __map((_r) => _r.body as Coupons)
    );
  }
}

module AdminCouponsService {
  /**
   * Parameters for AdminCouponsPutCoupons
   */
  export interface AdminCouponsPutCouponsParams {
    id: string;
    coupons: Coupons;
  }
}

export { AdminCouponsService };
